
const Config = require('config/js/lib/config.js');

module.exports = new Config({
	subsections: {
		domains: require('./domains'),
		pageUrls: require('./pageUrls'),
		siteID: require('./siteID'),
		environment: require('./environment'),
	},
});

